import script from "./Container.vue?vue&type=script&setup=true&lang=ts"
export * from "./Container.vue?vue&type=script&setup=true&lang=ts"

import "./Container.vue?vue&type=style&index=0&id=6d434823&scoped=true&lang=scss"

import exportComponent from "/opt/tiger/compile_path/src/code.byted.org/ad/se_tt4b_academy_advertiser_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d434823"]])

export default __exports__